<app-page-header
  [pageTitle]="'Registrar nuevo cliente'"
  [showBreadcrumb]="true"
  [backRoute]="'/crm/clientes'"
  [backLabel]="'Clientes'"
  [currentRoute]="'Crear'"
/>

<app-card [title]="'Datos generales'">
  <app-form [formGroup]="saveForm">
    <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
      <div>
        <app-label for="persona_tipo">
          Tipo de persona
        </app-label>
        <app-select id="persona_tipo" formControlName="persona_tipo" placeholder="Seleccione un tipo" [options]="personaTipoOptions" />
      </div>

      <div>
        <app-label for="nombre">
          @if (saveForm.get('persona_tipo')?.value === 'F') {
            Nombre completo
          } @else {
            Nombre
          }
        </app-label>
        <app-input-field id="nombre" name="nombre" formControlName="nombre" />
      </div>

      <!--
        El alta ya no separa nombre y apellido: el nombre completo va entero en `nombre`
        y el alta manda `apellido: null`. El control sigue en el formulario y el backend
        sigue aceptando el campo, así que reponer el apellido es descomentar este bloque.

      @if (saveForm.get('persona_tipo')?.value === 'F') {
        <div>
          <app-label for="apellido">
            Apellido
          </app-label>
          <app-input-field id="apellido" name="apellido" formControlName="apellido" />
        </div>
      }
      -->

      <div>
        <app-label for="per_documento_tipo_id">
          Tipo de documento
        </app-label>
        <app-select id="per_documento_tipo_id" formControlName="per_documento_tipo_id" placeholder="Seleccione un tipo" [options]="documentosTiposOptions" />
      </div>

      <div>
        <app-label for="numero">
          N° Documento
        </app-label>
        <app-input-field id="numero" name="numero" formControlName="numero" />
      </div>

      <div>
        <app-label for="ubi_pais_id">
          Ubicación
        </app-label>
        <app-select id="ubi_pais_id" formControlName="ubi_pais_id" placeholder="Seleccione una ubicación" [options]="paisesOptions" />
      </div>

      <div>
        <app-label for="param_tipo_cliente_id">
          Tipo de cliente
        </app-label>
        <app-select id="param_tipo_cliente_id" formControlName="param_tipo_cliente_id" placeholder="Seleccione un tipo" [options]="tiposClientesOptions" />
      </div>

      @if (saveForm.get('persona_tipo')?.value === 'J') {
        <div>
          <app-label for="nombre_fantasia">
            Nombre de fantasía
          </app-label>
          <app-input-field id="nombre_fantasia" name="nombre_fantasia" formControlName="nombre_fantasia" />
        </div>

        <div>
          <app-label for="fecha_constitucion">
            Fecha de constitución
          </app-label>
          <app-input-field id="fecha_constitucion" name="fecha_constitucion" formControlName="fecha_constitucion" type="date" />
        </div>
      }

      <div>
        <app-label for="direccion_fiscal">
          Dirección
        </app-label>
        <app-input-field id="direccion_fiscal" name="direccion_fiscal" formControlName="direccion_fiscal" />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Se guarda como dirección fiscal y completa los datos de facturación del cliente.
        </p>
      </div>

      <div>
        <app-label for="telefono">
          Teléfono
        </app-label>
        <app-input-field id="telefono" name="telefono" formControlName="telefono" />
      </div>

      <div>
        <app-label for="email">
          Email
        </app-label>
        <app-input-field id="email" name="email" formControlName="email" type="email" />
      </div>

      <!--
        Issue #24 (2026-09-15): sexo y fecha de nacimiento salen del alta de cliente.
        Los controles siguen en el formulario (mandan null) y el backend los sigue
        aceptando: para reponerlos alcanza con descomentar este bloque.

      @if (saveForm.get('persona_tipo')?.value === 'F') {
        <div>
          <app-label for="sexo">
            Sexo
          </app-label>
          <app-select id="sexo" formControlName="sexo" placeholder="Seleccione el sexo de la persona" [options]="sexoOptions" />
        </div>

        <div>
          <app-label for="fecha_nacimiento">
            Fecha de nacimiento
          </app-label>
          <app-input-field id="fecha_nacimiento" name="fecha_nacimiento" formControlName="fecha_nacimiento" type="date" />
        </div>
      }
      -->
    </div>
  </app-form>
</app-card>

<app-card [title]="'Establecimientos'" [className]="'mt-4'">
  <app-establecimientos-campos
    [filas]="establecimientos"
    [mostrarErrores]="mostrarErroresEstablecimientos"
    [deshabilitada]="loading"
  />
</app-card>

<!--
  2026-10-07: el contrato sale del alta (se carga después desde la ficha). El envío
  todavía lo manda si `conContrato` está tildado, así que reponerlo es descomentar.

<app-card [title]="'Contrato'" [className]="'mt-4'">
  <app-checkbox [formControl]="conContrato" label="Con contrato" />

  @if (conContrato.value) {
    <app-form [formGroup]="contratoForm">
      <div class="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2">
        <div>
          <app-label for="nro_contrato">N° de contrato</app-label>
          <app-input-field id="nro_contrato" formControlName="nro_contrato" />
        </div>

        <div>
          <app-label for="contrato_establecimiento">Establecimiento</app-label>
          <app-select id="contrato_establecimiento" formControlName="establecimiento"
            [placeholder]="establecimientosCargados.length === 1 ? establecimientosCargados[0].nombre : 'Sin establecimiento'"
            [options]="establecimientosContratoOptions" />
        </div>

        <div>
          <app-label for="fecha_inicio">Fecha de inicio</app-label>
          <app-input-field id="fecha_inicio" formControlName="fecha_inicio" type="date" />
        </div>

        <div>
          <app-label for="fecha_fin">Fecha de fin</app-label>
          <app-input-field id="fecha_fin" formControlName="fecha_fin" type="date" />
        </div>

        <div class="md:col-span-2">
          <app-label for="documento">Documento del contrato</app-label>
          <app-file-input id="documento" formControlName="documento" />
        </div>
      </div>
    </app-form>
  }
</app-card>
-->

<app-creation-buttons *hasPermission="'clientes:create'"
  [valid]="saveForm.valid"
  [process]="loading"
  (onCreateClick)="saveCliente()"
  (onCancelClick)="goBack()"
/>
